import { useState, type MouseEvent, type ReactNode } from "react";
import { Button, Popover, Typography } from "@mui/material";

type Props = {
  text: string;
  title?: string;
  emptyLabel?: string;
  icon?: ReactNode;
};

export function TextPreviewPopover({
  text,
  title = "הערות לשימוש פנימי",
  emptyLabel = "-",
  icon,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const trimmed = text?.trim() ?? "";

  if (!trimmed) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyLabel}
      </Typography>
    );
  }

  return (
    <>
      <Button
        size="small"
        variant="text"
        startIcon={icon}
        onClick={(e: MouseEvent<HTMLElement>) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        sx={{ textTransform: "none", minWidth: 0, px: 0.5 }}
      >
        <Typography variant="body2" noWrap title={trimmed} sx={{ maxWidth: 140 }}>
          {trimmed.length > 36 ? `${trimmed.slice(0, 36)}…` : trimmed}
        </Typography>
      </Button>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { maxWidth: 400, p: 2 } } }}
      >
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", lineHeight: 1.7 }}>
          {trimmed}
        </Typography>
      </Popover>
    </>
  );
}
